module.exports = __webpack_public_path__ + "static/media/abbey-park-2.63af7176.jpg";